/// <reference path="../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class AccountActivationController {
        public static $inject: string[] = [
            '$mdDialog',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'CurrentLocation',
            'CurrentUser'
        ];

        public location: any;
        public activeStep: number;
        public steps: any;

        constructor(public $mdDialog: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public CurrentLocation: any,
                    public CurrentUser: any) {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Loading...');
            this.CurrentLocation.get().then(
                function(location: any) {
                    _self.location = location.data;

                    _self.activeStep = 0;
                    _self.steps = [
                        { type: 'loaner-agreement-upload', title: 'Upload Driver Agreement', progress: 0 },
                        { type: 'loaner-agreement-summary', title: 'Driver Agreement Terms', progress: 0, completeOnShow: true },
                        { type: 'fleet-upload', title: 'Upload Fleet', progress: 0 },
                        { type: 'days-open', title: 'Days of Operation', progress: 0, completeOnShow: true },
                        { type: 'expenses', title: 'Configure Expenses', progress: 0, completeOnShow: true },
                        { type: 'location-business', title: 'Location Business', progress: 0, completeOnShow: true }

                    ];
                }
            ).finally(
                function() { loader.close(); }
            );
        }

        public goToStep(step: number) : void {
            this.activeStep = step;
            if (this.steps[step].completeOnShow) { this.updateProgress(step); }
        };

        public nextStep() : void {
            this.activeStep = this.activeStep < this.steps.length-1 ? this.activeStep+1 : 0;
            if (this.steps[this.activeStep].completeOnShow) { this.updateProgress(this.activeStep); }
        };

        public updateProgress(step: number) : void {
            this.steps[step].progress = 100;
        };

        public anyStepsIncomplete() : boolean {
            return this.steps.some(function(step: any) { return step.progress < 100; })
        };

        public finish() : void {
            var _self = this;

            this.CurrentUser.user.$clearActivationRequired({
                promise: true,
                params: { location_id: this.location.id }
            }).then(
                function(returnData: any) {
                    _self.CurrentUser.user.data.company_activation_required = returnData.data.company_activation_required;
                    _self.$mdDialog.show({
                        templateUrl: '/content/settings/account_activation_success.html',
                        controller: _self.modalController,
                        clickOutsideToClose: true
                    });
                },
                function(response: any) { _self.$dealerwareNotification.apiError(response); }
            );
        }

        public get modalController() {
            return function($scope: any,
                            $state: any,
                            $mdDialog: any,
                            CurrentUser: any) {
                $scope.employee = CurrentUser.user;

                $scope.close = function() {
                    $mdDialog.hide();
                    $state.go('shortcuts.dashboard');
                }
            }
        }
    }

    getDealerwareWebContentModule().controller('AccountActivationController', AccountActivationController);
}
